import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CalendarColumnHeaderType } from '../../types';
import { ColumnHeader } from './column-header';

interface SortableColumnHeaderProps {
  columnId: string;
  headerType: CalendarColumnHeaderType;
}

export const SortableColumnHeader = ({ columnId, headerType }: SortableColumnHeaderProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: columnId });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
        cursor: 'grab',
      }}
      {...attributes}
      {...listeners}
    >
      <ColumnHeader columnId={columnId} headerType={headerType} />
    </div>
  );
};
